<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Hunting-Words-Generator-Root',
};
</script>
